<template>
  <div>
    <IconButton
      icon="mdi-clock-time-eight-outline"
      :tooltip-text="$t('confirm.inactionTime')"
      @click="showDialog = true"
    />
    
    <v-dialog v-model="showDialog" max-width="600">
      <v-card>
        <v-card-title>{{ $t('confirm.changeInactionTime') }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="inactionTimeValue"
            :label="$t('confirm.inactionTime') + ' (' + $t('minutes') + ')'"
            :error-messages="inactionTimeError"
            @blur="validateInactionTime"
            required
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="showDialog = false">
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn 
            color="green darken-1" 
            :disabled="inactionTimeError !== ''"
            text @click="saveInactionTime"
          >
            {{ $t('Save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IconButton from './IconButton.vue';
import { notifySuccess, notifyError } from '../../services/notifications.js';

export default {
  name: 'InactionTimeButton',
  components: {
    IconButton
  },
  data() {
    return {
      showDialog: false,
      inactionTimeValue: '',
      inactionTimeError: ''
    };
  },
  methods: {
    validateInactionTime() {
      const value = this.inactionTimeValue;

      if (!value || value.length === 0) {
        this.inactionTimeError = this.$t('validations.notEmpty');

        return;
      }

      if (!value.match(/^[1-9]\d*$/)) {
        this.inactionTimeError = this.$t('confirm.mustBeDigits');

        return;
      }

      this.inactionTimeError = '';
    },
    
    saveInactionTime() {
      if (this.inactionTimeError !== '') return;

      const user = this.$store.getters.USER_DATA;
      user.timeout = parseInt(this.inactionTimeValue, 10);
      this.$axios.users
        .putByIdTimeout(user.userId, user)
        .then(() => {
          notifySuccess(
            '',
            this.$t('Messages.UserInactionTimeChanged', [user.name])
          );
          this.showDialog = false;
          this.inactionTimeValue = '';
        })
        .catch((error) => {
          console.error(error);
          notifyError(
            '',
            this.$t('Messages.ErrorOccuredWhileEditingUser', [user.name])
          );
        });
    }
  },
  watch: {
    showDialog() {
      this.inactionTimeValue = '';
      this.inactionTimeError = '';
    }
  }
};
</script>
